import mapboxgl from 'mapbox-gl';

export default {
  init($element) {

  },
  finalize($element) {

    var popups = [];

    const $dataEl = $('#map-data');

    const zoom_start_level = $dataEl.data('zoom-start-level');
    const zoom_max_level = $dataEl.data('zoom-max-level');
    const zoom_min_level = $dataEl.data('zoom-min-level');
    const map_centre_lat = $dataEl.data('map-centre-lat');
    const map_centre_lng = $dataEl.data('map-centre-lng');
    const data = $dataEl.data('json');
    const terms = $dataEl.data('terms');
    const default_layers = $dataEl.data('attractions');
    const accessToken = $dataEl.data('access-token');
    const homeUrl = $dataEl.data('home-url');
    const viewDetailsLabel = $dataEl.data('view-details-label');

    if ($element.hasClass('fullscreen')) {
      $element.find('#map-wrapper').css({ 'height': $(window).innerHeight() + 'px' });
    }

    mapboxgl.accessToken = accessToken;
    const map = new mapboxgl.Map({
      container: 'map',
      fadeDuration: 0,
      minZoom: (zoom_min_level) ? zoom_min_level : 13,
      maxZoom: (zoom_max_level) ? zoom_max_level : 18,
      style: 'https://api.os.uk/maps/vector/v1/vts/resources/styles',
      center: [(map_centre_lng) ? map_centre_lng : -3.8119933 , (map_centre_lat) ? map_centre_lat : 53.0910704], // TODO need default start coords from client
      zoom: (zoom_start_level) ? zoom_start_level : 14,
      transformRequest: (url, resourceType) => {
        /**
         * Uses OAuth 2. Access token is generated via PHP function.
         * @see {https://github.com/tmnnrs/os-data-hub-oauth2-api/blob/master/examples/mapbox-gl-js/os-vector-tile-api.html}
         */
        const loc = new URL(url);
        const check = loc.protocol + '//' + loc.hostname;
        if (check !== homeUrl) {
          return {
            headers: {'Authorization': `Bearer ${accessToken}`},
            url: url.split('?')[0] + '?srs=3857',
          }
        }
      },
    });

    // Prevent wheel scroll
    if (!$dataEl.data('can-scroll-zoom')) {
      map.scrollZoom.disable();
    }

    // Disable drag/touch rotation.
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();
    
    map.on('load', () => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          map.addSource(key, data[key]);
        }
      }
      for (let i = 0; i < terms.length; i++) {
        const obj = terms[i];
        if (obj.children.length > 0) {
          for (let j = 0; j < obj.children.length; j++) {
            const obj_child = obj.children[j];
            if (obj_child.hasOwnProperty('slug') && obj_child.slug && obj_child.hasOwnProperty('map_icon') && obj_child.map_icon) {
              add_pin(map, obj_child);
            }
          }
        } else {
          if (obj.hasOwnProperty('slug') && obj.slug && obj.hasOwnProperty('map_icon') && obj.map_icon) {
            add_pin(map, obj);
          }
        }
      }
      map.on('idle', () => {
        $('#map').addClass('loaded');
        const menu = document.getElementById('map-filter');
        if (menu) {
          const links = menu.getElementsByClassName('layer');
          for (const link of links) {
            link.onclick = function (e) {
              const clickedLayer = this.id;
              e.preventDefault();
              e.stopPropagation();
              if (this.classList.contains('has-children')) {

                if (this.classList.contains('active')) {
                  $(this).find('input[type="checkbox"]').get()[0].checked = false;
                  $(this).removeClass('active');
                  $(this).siblings('.children').find('.layer').each(function() {
                    $(this).removeClass('active');
                    $(this).find('input[type="checkbox"]').get()[0].checked = false;
                    map.setLayoutProperty($(this).prop('id'), 'visibility', 'none');
                  });
                } else {
                  $(this).find('input[type="checkbox"]').get()[0].checked = false;
                  $(this).addClass('active');
                  $(this).siblings('.children').find('.layer').each(function() {
                    $(this).addClass('active');
                    $(this).find('input[type="checkbox"]').get()[0].checked = true;
                    map.setLayoutProperty(
                      $(this).prop('id'),
                      'visibility',
                      'visible'
                    );
                  });
                }

                setSelected();

                // const inputParent = 'check-' + clickedLayer;
                // const children = jQuery(this).parent().find('.children');
                // const links = children.find('a.layer');
                // for (const link of links) {
                  // console.log('Toggle A');
                  // toggle(link.getAttribute('id'), map, inputParent);
                // }
              } else {
                toggle(clickedLayer, map, '');
              }
            };
          }
        }
      });
    });

    const resetBtn = document.getElementById('reset');
    if (resetBtn) {
      resetBtn.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const menu = document.getElementById('map-filter');
        const links = menu.getElementsByClassName('layer');
        for (const link of links) {
          const clickedLayer = link.getAttribute('id');
          const inputParent = 'check-' + clickedLayer;
          document.getElementById(inputParent).checked = false;
          if (link.classList.contains('has-children')) {
            const children = jQuery(this).parent().find('.children');
            const links = children.find('a.layer');
            for (const link of links) {
              reset(link.getAttribute('id'), map, false);
            }

            link.classList.remove('active');
          } else {
            reset(clickedLayer, map, false);
          }
        }
      }
    }

    const filterToggle = document.getElementById('btn-filter-toggle');
    if (filterToggle) {
      filterToggle.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const menu = jQuery('#map-filter');
        if (menu.css('display') === 'none') {
          menu.css('display', 'block');
        } else {
          menu.css('display', 'none');
        }
      }
    }

    /**
     * Render a pin onto the map and add the pin popup info.
     *
     * @param {map} map Map object created.
     * @param {obj} obj Array of terms objects.
     */
    function add_pin(map, obj) {
      map.loadImage(obj.map_icon, (error, image) => {
        if (error) throw error;
        let visibility = 'visible';
        if (default_layers) {
          visibility = (default_layers.includes(obj.term_id)) ? 'visible' : 'none';
        }
        map.addImage(obj.slug, image);
        map.addLayer({
          'id': obj.slug,
          'type': 'symbol',
          'source': obj.slug,
          'layout': {
            'visibility': visibility,
            'icon-image': obj.slug,
            'icon-allow-overlap': true,
            'icon-size': 0.25,
            'icon-anchor': 'bottom',
          },
        });
        map.on('mouseover', obj.slug, (e) => {
          $('#map .mapboxgl-canvas').css({ 'cursor': 'pointer' });
        });
        map.on('mouseout', obj.slug, (e) => {
          $('#map .mapboxgl-canvas').css({ 'cursor': 'grab' });
        });
        map.on('click', obj.slug, (e) => {
          const coordinates = e.features[0].geometry.coordinates.slice();
          const title = e.features[0].properties.title;
          const description = e.features[0].properties.description;
          const link = e.features[0].properties.link;
          const img = e.features[0].properties.img;
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          let html = '<h3>' + title + '</h3>';
          if (img !== 'null' && img !== '') {
            html += '<img src="' + img + '" alt="' + title + '" />';
          }
          html += '<p>' + description + '</p>';
          if (link !== 'null' && link !== '') {
            html += '<p><a href="' + link + '" target="_blank">' + viewDetailsLabel + '</a></p>';
          }

          if (description != '' || link != '' || img !== 'null') {
            popups.forEach((popup) => {
              popup.remove();
            });

            popups.push(new mapboxgl.Popup()
              .setLngLat(coordinates)
              .setHTML(html)
              .addTo(map));
          }
        });
      });
    }

    /**
     * Toggle layers' visibility.
     *
     * @param {string} clickedLayer The ID of the a tag, which is the same as the ID of the layer.
     * @param {map} map The map object.
     * @param {string} inputParent Parent input ID for toggling checkbox.
     */
    function toggle(clickedLayer, map, inputParent) {
      const link = document.getElementById(clickedLayer);
      const input = document.getElementById('check-' + clickedLayer);
      const visibility = map.getLayoutProperty(
        clickedLayer,
        'visibility'
      );
      if (visibility === 'visible') {

        // Select all clicked
        if (inputParent === '') {
          link.classList.remove('active');
          input.checked = false;
          map.setLayoutProperty(clickedLayer, 'visibility', 'none');
        }

      } else {

        // Select all clicked
        if (inputParent === '') {
          link.classList.add('active');
          input.checked = true;

          map.setLayoutProperty(
            clickedLayer,
            'visibility',
            'visible'
          );
        }
      }

      if (inputParent === '') {
        // Check if all are selected
        var allSelected = true;
        var numSelected = 0;
        $(link).parent().find('.layer').each(function() {
          if (!$(this).hasClass('active')) {
            allSelected = false;
          } else {
            numSelected++;
          }
        });

        if (allSelected) {
          $(link).parent().siblings('.layer.has-children').addClass('active');
        } else {
          $(link).parent().siblings('.layer.has-children').removeClass('active');
        }
      }

      setSelected();
    }

    function setSelected() {
      $('#map-filter .toggle').each(function() {
        const thisHref = $(this).attr('href').replace('#', '');
        const $cat = $(`#map-filter #${thisHref}`);

        var numSelected = 0;

        $cat.find('.children .layer').each(function() {
          if ($(this).hasClass('active')) {
            numSelected++;
          }
        });

        if (numSelected > 0) {
          $(this).addClass('has-selection');
          $(this).find('.toggle-selection .selection-count').html(numSelected);
        } else {
          $(this).removeClass('has-selection');
        }
      });
    }

    /**
     * Reset all the map pins by making them all active, the default pin state.
     * 
     * Unless explicitly deactivated, for instance when clicking the Clear button.
     *
     * This will set all the layers to visibile regardless of whether they were
     * already visible or not.
     *
     * @param {string} clickedLayer The ID of the a tag, which is the same as the ID of the layer.
     * @param {map} map The map object.
     * @param {boolean} active Whether the pins should be set to active or not.
     */
    function reset(clickedLayer, map, active = true) {
      const link = document.getElementById(clickedLayer);
      const input = document.getElementById('check-' + clickedLayer);

      if (active) {
        input.checked = true;
        link.classList.add('active');
        map.setLayoutProperty(
          clickedLayer,
          'visibility',
          'visible'
        );
      } else {
        input.checked = false;
        link.classList.remove('active');
        map.setLayoutProperty(
          clickedLayer,
          'visibility',
          'none'
        );
      }
    }

    // Open mobile filter wrap
    $('#map-filter-toggle').on('click', function() {
      $('#map-filter').addClass('open');
    });

    // Close mobile filter wrap
    $('#map-filter .map-filter-close').on('click', function() {
      $('#map-filter').removeClass('open');
    });

    // Zoom in
    $('.map-controls-zoom-in').on('click', function() {
      map.zoomIn();
    });

    // Zoom out
    $('.map-controls-zoom-out').on('click', function() {
      map.zoomOut();
    });

    setSelected();
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/shared/map.js